/* eslint-disable no-alert, no-console */
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "utils/api-client-wrapper";
import type { GetV1UsersAddressesIdQueryResponse, GetV1UsersAddressesIdPathParams, GetV1UsersAddressesId404 } from "../../../types/GetV1UsersAddressesId.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "utils/api-client-wrapper";

function getGetV1UsersAddressesIdUrlClient({ id }: { id: GetV1UsersAddressesIdPathParams["id"] }) {
  const res = { method: 'GET', url: `/v1/users/addresses/${id}` as const }
  return res
}

/**
 * @summary Get address details
 * {@link /v1/users/addresses/:id}
 */
export async function getV1UsersAddressesIdClient({ id }: { id: GetV1UsersAddressesIdPathParams["id"] }, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetV1UsersAddressesIdQueryResponse, ResponseErrorConfig<GetV1UsersAddressesId404>, unknown>({ method : "GET", url : getGetV1UsersAddressesIdUrlClient({ id }).url.toString(), ... requestConfig })
  return res
}